export default class ApplicationFacade {
  gateways = {};

  notificationManager = null;

  history = null;
}



// WEBPACK FOOTER //
// ./src/infrastructure/ApplicationFacade.js